import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const ExportInductionModulePdfRange = (ApiData) => async (dispatch) => {
  try {
const storedData = JSON.parse(localStorage.getItem("LoginUserData"));

    const response = await axios({
      method: "put",
      data: ApiData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/provider/worker/ExportInductionModulePdfRange`,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
